<template>
  <div>
    <v-flex xs12 v-if="showReloadMessage">
      <form-alert-full></form-alert-full>
    </v-flex>

    <v-toolbar fixed app>
      <v-toolbar-side-icon v-if="displayGoBackIcon" @click.stop="redirectBack" id="nova_proposta">
        <v-icon>arrow_back</v-icon>
      </v-toolbar-side-icon>

      <v-toolbar-title v-if="displayPageTitle" v-html="pageName" />
      <v-toolbar-title v-if="$route.name == 'Visualizar Produto'" />

      <p class="text-left greetings" v-if="isEditarPropostaPage">
        <a @click="redirectToTimeLine()">
          <span class="font-weight-bold white--text">Resumo</span>
          <v-toolbar-side-icon>
            <v-icon>info_outline</v-icon>
          </v-toolbar-side-icon>
        </a>
      </p>
      <p v-if="!isNovaPropostaPage" class="align-right greetings"></p>

      <!-- Hidden fields para automatização -->
      <input type="hidden" id="corretor_CNPJ" :value="me.company.document" />
      <input
        type="hidden"
        id="corretor_Segmento"
        :value="me.company.segmento"
      />
      <p v-if="(!isNovaPropostaPage || !isEditarPropostaPage) && (!$route.meta.formPage || true)" class="align-right greetings" >
        <v-list two-line class="toolbar__avatar">
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ me.company.name }}
                <span>({{ me.name }})</span>
              </v-list-tile-title>

              <v-list-tile-sub-title 
                @click.stop="setMini(true)"
                v-if="(!isNovaPropostaPage && !isEditarPropostaPage) && (!$route.meta.formPage || true)"
              >
                <router-link :to="{ path: '/perfil' }" class="right" id="perfil_corretor"
                  >Perfil do Corretor</router-link
                >
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </p>
    </v-toolbar>

    <v-navigation-drawer
      :mini-variant.sync="mini"
      :width="!mini ? '184' : ''"
      v-model="fullDrawer"
      app
      hide-overlay
      stateless
      v-if="!$route.meta.formPage || false"
      class="lateralmenu"
    >
      <v-layout align-center row spacer class="lateralmenu-avatar">
        <v-flex xs12>
          <img
            :src="require('../assets/_2/ic_logo_jns_login.png')"
            alt
            @click.stop="redirect({ path: '/home' })"
          />
        </v-flex>
      </v-layout>

      <v-list>
        <div
          v-for="item in $settings.menuSidebar"
          :key="item.title"
          :id="item.title.replace(/ /g, '')"
          v-show="item.title"
          
        >
          <v-divider
            v-if="item.title == 'Logout' || item.title == 'Ocultar'"
            :class="item.actionCollapse ? 'divider-collapse-menu' : ''"
          ></v-divider>
          <v-list-tile
            dense
            :value="item.active"
            mb-2
            @click.stop="redirect(item)"
            :class="
              item.actionCollapse
                ? 'collapse-menu item-list'
                : $route.path == item.path
                ? 'item-list-router'
                : 'item-list'
            "
          >
            <v-list-tile-action>
              <svg-icon v-if="!item.action">{{ item.icon }}</svg-icon>
              <v-icon class="material-icons" v-if="item.action">{{
                item.isMenuIcon && mini ? item.actionCollapse : item.action
              }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script lang="js">
import axios from "axios";
import { mapActions } from "vuex";

export default {
  name: "JNSMenu",
  data() {
    return {
      mini: true,
      fullDrawer: true,
      reloadModal: false,
      axios,
      checkVersionInterval: false,
      COMMIT_HASH: COMMIT_HASH,
      showReloadMessage: false,
      showDrawer: false,
    };
  },
  computed: {
    isNovaPropostaPage() {
      return this.$route.name === 'Nova Proposta';
    },
    isEditarPropostaPage() {
      return this.$route.name === 'Editar Proposta';
    },
    isSolicitarEndossoPage() {
      return this.$route.name === 'Solicitação de Endosso';
    },

    displayGoBackIcon() {
      return this.$route.meta.formPage || false;
    },

    displayPageTitle() {
      return !this.$route.meta.formPage || true;
    },

    store() {
      return this.$store;
    },

    me() {
      var meJson = JSON.parse(localStorage.getItem("me"));
      return meJson;
    },

    pageName() {
      return this.$store.state.main.pageName;
    },

    route() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapActions(["GET_VERSION"]),

    async init() {
      await this.getVersion();
      this.checkVersionInterval = setInterval(this.getVersion, 1000 * 60 * 15);
    },

    async getVersion() {
      try {
        const version = await this.GET_VERSION();
        let buildVersion = COMMIT_HASH;

        if (version !== buildVersion) {
          this.showReloadMessage = true;
        } else {
          this.showReloadMessage = false;
        }
      } catch (e) {
        //console.warn(e);
      }
    },

    redirect(item) {
      if (item.isMenuIcon) this.setMini(!this.mini);
      if (item.title == "Logout") this.logout();
      else if (!item.subItems) {
        this.$router.push(item.path);
      }

      if (!this.mini) this.setMini(true);
    },

    redirectToTimeLine() {
      let id = this.$router.app._route.params.propostaId;
      let produto = this.$router.app._route.params.produtoId;
      this.$router.push({ path: `/proposta/${id}/${produto}` });
    },

    redirectBack() {
      if (this.isEditarPropostaPage) this.redirectToTimeLine();
      else if (this.pageName == "Listar Recibos") this.$router.push({ path: "/recibos" });
      else if (this.isSolicitarEndossoPage) this.$router.go(-1); 
      else this.$router.push({ path: "/home" });
      
      if (!this.mini) this.setMini(true);
    },

    logout() {
      this.$router.push({ name: "ConnectionGuard" });
      delete this.axios.defaults.headers.common["Authorization"];
    },

    setMini(value) {
      this.mini = value;
      this.$forceUpdate();
    },
  },
  mounted() {
    document.title = this.$route.name + " - JNS ";
    this.$store.commit("SET_PAGENAME", this.$route.name);
    this.init();
  },
  destroyed() {
    clearInterval(this.checkVersionInterval);
  },
  watch: {
    route(newRoute, oldRoute) {
      document.title = this.$route.name + " - JNS ";
      this.$store.commit("SET_PAGENAME", newRoute);
      this.$forceUpdate();
    },

    showDrawer: function (value) {
      this.mini = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  .v-divider {
    display: flex !important;
    border-color: #ffffff !important;
    margin: 1vh 0;
  }

  .v-list__tile__action {
    margin: auto;
    justify-content: end !important;
  }

  &--mini-variant {
    .lateralmenu-avatar {
      margin-top: 0;
      height: 64px;
    }

    img {
      padding-top: 0.5vh;
      width: 50px;
      min-height: 44px;
    }
  }
}

.lateralmenu {
  height: 90vh;
  position: fixed;
}

.avatar {
  display: inline-block;
}

.lateralmenu-avatar {
  text-align: center;
  margin-top: 31px;
  position: relative;
  cursor: pointer;
}

.mini-avatar {
  position: absolute;
  bottom: 0;
  right: 40px;
}

.lateralmenu-userinfo {
  margin-top: 30px;
  margin-bottom: 30px;
  padding-left: 35px;
}

.lateralmenu-username {
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
  padding-bottom: 0;
}

.lateralmenu-ver-perfil {
  font-size: 16px;
  color: #bbb;
  margin-top: 0px;
  padding-top: 0;
}

.application .theme--light.v-navigation-drawer .list,
.application .theme--light.v-navigation-drawer a:not(.list__tile--active),
.theme--light .v-navigation-drawer .list,
.theme--light .v-navigation-drawer a:not(.list__tile--active) {
  color: #999;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

.logo-avatar {
  background-color: white;

  img {
    width: auto;
    height: auto;
  }
}

.lateralmenu /deep/ .v-list__tile__title {
  white-space: normal;
  height: auto;
}

.lateralmenu /deep/ .v-list__tile__action {
  svg {
    margin-left: 20px;

    & g,
    & path {
      transition: all 0.2s ease;
      fill: #fff;
    }
  }

  i {
    color: #fff !important;
    margin-left: 17px !important;
    font-size: 25px !important;
  }
}

.card__visualizar-todas {
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background-color: #eee;
  }
}

.collapse-menu {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin-bottom: 0.5vh;
  height: 51px;
}

.divider-collapse-menu {
  @extend .collapse-menu;
  bottom: 51px !important;
}

.text-left {
  margin-left: 60px !important;
}
</style>



// WEBPACK FOOTER //
// ./src/components/JNSMenu.vue